import { Helmet } from 'react-helmet-async';

// SEO meta data for each page
const seoData = {
  home: {
    title: 'Artistry House | Premium Hair, Beauty & Wellness Camberwell',
    description: "Experience Melbourne's premier destination for hair artistry and advanced skin. From expert styling to holistic wellness in Camberwell, Artistry House delivers luxury results. Book your transformation today.",
    keywords: 'hairdresser camberwell, hair salon camberwell, beauty salon camberwell, wellness camberwell, hair extensions melbourne',
    canonical: '/'
  },
  hair: {
    title: 'Hair Services & Styling Camberwell | Artistry House Hair Artistry',
    description: 'Expert hair cutting, colouring, balayage, and styling services in Camberwell. Located just off Burke Road in the heart of Camberwell. 45+ years of experience. Book your appointment today.',
    keywords: 'hairdresser camberwell, hair salon camberwell, balayage camberwell, hair colouring melbourne, foils camberwell',
    canonical: '/hair'
  },
  hairExtensions: {
    title: 'Best Hair Extensions Camberwell | Artistry House Hair Artistry',
    description: "Looking for the best quality hair extensions in Camberwell? We specialize in seamless, high-end Great Lengths extensions including keratin bonds, tape, and weft. Achieve your dream length and volume.",
    keywords: 'hair extensions camberwell, tape extensions melbourne, weft extensions camberwell, keratin bond extensions, great lengths melbourne',
    canonical: '/hair-extensions'
  },
  blondeSpecialist: {
    title: 'Blondes & Colour Specialist Camberwell | Balayage, Foils & Colour | Artistry House',
    description: "Camberwell's destination for perfect blondes and flawless colour. From creamy balayage to colour correction, all-over colour, and lived-in blonde — our specialists focus on hair health and precision results.",
    keywords: 'blonde specialist camberwell, balayage camberwell, hair colour melbourne, colour correction, foils camberwell, platinum blonde melbourne',
    canonical: '/blonde-specialist'
  },
  beauty: {
    title: 'Beauty Services & Facials Camberwell | Artistry House Beauty',
    description: 'Advanced beauty treatments in Camberwell including facials, skin rejuvenation, lash lifts, brow lamination, and more. Located near Camberwell Junction on Burke Road. Book your treatment today.',
    keywords: 'beauty salon camberwell, facials camberwell, skin rejuvenation melbourne, lash lift camberwell, brow lamination melbourne',
    canonical: '/beauty'
  },
  beautyPriceList: {
    title: 'Beauty Price List | Facials, LED, HIFU, Laser | Artistry House Camberwell',
    description: 'View our full beauty price list including facials, LED light therapy, microdermabrasion, HIFU, super hair removal, waterfall head spa and packages at Artistry House Camberwell.',
    keywords: 'beauty prices camberwell, facial prices melbourne, LED therapy cost, HIFU price, laser hair removal prices camberwell',
    canonical: '/beauty-price-list'
  },
  hifu: {
    title: 'HIFU Face Lifting Camberwell | Non-Surgical Facelift | Artistry House',
    description: 'Non-surgical face lifting with HIFU at Artistry House Camberwell. Tighten, sculpt, and rejuvenate your skin naturally with focused ultrasound technology. No needles, no downtime.',
    keywords: 'hifu camberwell, non surgical facelift melbourne, hifu face lifting, skin tightening camberwell, hifu treatment melbourne',
    canonical: '/hifu'
  },
  superHairRemoval: {
    title: 'Super Hair Removal Camberwell | Painless Laser Hair Removal | Artistry House',
    description: 'Painless Super Hair Removal (SHR) in Camberwell. Advanced cooling-tip technology safe for all skin types. Say goodbye to shaving and ingrown hairs. Book your free consultation.',
    keywords: 'super hair removal camberwell, painless hair removal melbourne, shr treatment, laser hair removal camberwell, permanent hair removal melbourne',
    canonical: '/super-hair-removal'
  },
  facials: {
    title: 'Facials & Skin Rejuvenation Camberwell | Advanced Skin Treatments',
    description: 'Searching for "best quality facials near me"? Artistry House offers advanced skin rejuvenation in Camberwell, including LED therapy, hydrafacials, and medical-grade peels for glowing results.',
    keywords: 'facials camberwell, best facials near me, skin rejuvenation melbourne, hydrafacial camberwell, led facial melbourne',
    canonical: '/facials'
  },
  laserHairRemoval: {
    title: 'Painless Laser Hair Removal Camberwell | Artistry House Beauty',
    description: 'Silky smooth skin with painless laser hair removal in Camberwell. Our advanced technology is safe for all skin types. Effective, fast, and professional treatments at Artistry House.',
    keywords: 'laser hair removal camberwell, painless laser melbourne, ipl camberwell, permanent hair removal melbourne',
    canonical: '/laser-hair-removal'
  },
  wellness: {
    title: 'Wellness, Massage & Head Spa Camberwell | Artistry House',
    description: 'Escape to our Camberwell wellness sanctuary. Specializing in Waterfall Head Spas, Remedial Massage, Lymphatic Drainage, and Oncology Massage. Rejuvenate your mind and body near Burke Road.',
    keywords: 'wellness camberwell, massage camberwell, head spa melbourne, relaxation camberwell, holistic wellness melbourne',
    canonical: '/wellness'
  },
  remedialMassage: {
    title: 'Remedial Massage Camberwell | Chronic Pain Relief & Recovery',
    description: 'Professional remedial massage in Camberwell for pain relief, injury recovery, and stress reduction. Health fund rebates available via HICAPS. Experience expert care at Artistry House of Wellness.',
    keywords: 'remedial massage camberwell, massage health fund rebate, chronic pain relief melbourne, sports massage camberwell, deep tissue massage',
    canonical: '/remedial-massage'
  },
  menopauseWellness: {
    title: 'Menopause & Wellness Coaching Camberwell | Artistry House',
    description: 'Personalised menopause and wellness coaching in Camberwell. Holistic support for perimenopause, menopause, and post-menopause including symptom management, nutrition guidance, and targeted spa treatments.',
    keywords: 'menopause coaching camberwell, wellness coaching melbourne, perimenopause support, menopause treatment, holistic wellness camberwell',
    canonical: '/menopause-wellness'
  },
  ourProducts: {
    title: 'La Biosthetique Hair Products | Premium Colour & Care | Artistry House Camberwell',
    description: 'At Artistry House we exclusively use La Biosthetique Paris for hair colour, haircare, and scalp treatments. Born in Paris, made in Germany — 90% natural ingredients, carbon neutral, cruelty-free.',
    keywords: 'la biosthetique camberwell, premium hair products melbourne, hair colour products, scalp treatment, luxury haircare camberwell',
    canonical: '/our-products'
  },
  aspectSkincare: {
    title: 'Aspect Skincare | Carbon Neutral Cosmeceutical Skincare | Artistry House Camberwell',
    description: 'Artistry House uses and recommends Aspect Skincare — a leading Australian cosmeceutical brand. Carbon neutral, result-driven formulations for radiant, healthy-looking skin.',
    keywords: 'aspect skincare camberwell, cosmeceutical skincare melbourne, carbon neutral skincare, professional skin care products, facial products camberwell',
    canonical: '/aspect-skincare'
  },
  sustainability: {
    title: 'Sustainable Salon Camberwell | Eco-Friendly Hair & Beauty',
    description: 'Artistry House is a proud Sustainable Salons member. 95% of salon waste rescued from landfill. When you book with us, you automatically give back to the environment. Ponytail donations welcome.',
    keywords: 'sustainable salon camberwell, eco-friendly hair salon melbourne, sustainable salons australia, ponytail donation melbourne',
    canonical: '/sustainability'
  },
  contact: {
    title: 'Contact Artistry House | Hair & Beauty Salon Camberwell',
    description: 'Book your appointment at Artistry House, 925 Burke Road, Camberwell VIC 3124. Call (03) 9882 6969 or book online. Located near Camberwell Junction, easy parking available.',
    keywords: 'artistry house contact, camberwell hair salon phone, book hairdresser camberwell, burke road salon',
    canonical: '/contact'
  }
};

export function SEO({ page }) {
  const data = seoData[page] || seoData.home;
  const baseUrl = 'https://artistryhousehbw.com';
  
  return (
    <Helmet>
      <title>{data.title}</title>
      <meta name="description" content={data.description} />
      <meta name="keywords" content={data.keywords} />
      <link rel="canonical" href={`${baseUrl}${data.canonical}`} />
      
      {/* Open Graph */}
      <meta property="og:title" content={data.title} />
      <meta property="og:description" content={data.description} />
      <meta property="og:url" content={`${baseUrl}${data.canonical}`} />
      <meta property="og:type" content="website" />
      
      {/* Twitter */}
      <meta name="twitter:title" content={data.title} />
      <meta name="twitter:description" content={data.description} />
    </Helmet>
  );
}

export default SEO;
